import axios from "axios";

const state = {
  documentTypes: [],
};

const getters = {
  documentTypes(state) {
    return state.documentTypes;
  },
};

const mutations = {
  setDocumentTypes(state, documentTypes) {
    state.documentTypes = documentTypes;
  },
};

const actions = {
  async fetchDocumentTypes({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/document-type/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setDocumentTypes", res.data);
      });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
